import NewTicket from "./NewTicket";
import NewTicketProvider from "./NewTicketContext";

let Index = () => {

    return (
        <NewTicketProvider>
            <NewTicket />
        </NewTicketProvider>
    );
}


export default Index;